<script lang="ts">
	import Dialog from '$lib/components/Common/Dialog/Dialog.svelte'
	import { isNumeric } from '$lib/functions/formatters'
	import { messages } from '$lib/messages'
	import { dimensions } from '$lib/stores/dimensions'
	import { calculated as invoice } from '$lib/stores/invoice/invoice'
	import { setDocument } from '$lib/stores/invoice/manager'

	// init checkboxs
	let checkedFirst = $invoice.reminder_overdue_days_1 > 0
	let checkedSecond = $invoice.reminder_overdue_days_2 > 0
	let disabledInputFirst = false
	let disabledInputSecond = false
	let disabledCheckedFirst = false
	let disabledCheckedSecond = false

	//$: disabledInputFirst = !checkedFirst
	//$: disabledInputSecond = !checkedSecond

	//$: disabledCheckedFirst = checkedSecond
	//$: disabledCheckedSecond = !checkedFirst || (checkedFirst && $invoice.reminder_overdue_days_1 == 0)

	const handleCheckFirst = (checked: boolean) => {
		if (!checked) {
			setDocument({ reminder_overdue_days_1: 0, reminder_overdue_days_2: 0 })
			checkedSecond = false
		}
	}

	const handleCheckSecond = (checked: boolean) => {
		if (!checked) setDocument({ reminder_overdue_days_2: 0 })
	}

	const handleInput = (value: string) => {
		let days: number
		if (isNumeric(value)) {
			days = +value
			if (days < 0) messages.error('The number of days must be greater than zero.')
			else if ($invoice.reminder_overdue_days_1 > 0 && $invoice.reminder_overdue_days_1 <= days)
				messages.error('The number of days must be less than the next reminder.')
			else setDocument({ reminder_overdue_days: days })
		} else messages.error('The number of days must be numeric.')
	}

	const handleInputFirst = (value: string) => {
		let days: number
		if (isNumeric(value)) {
			days = +value
			if (days < 0) messages.error('The number of days must be greater than zero.')
			else if ($invoice.reminder_overdue_days >= days)
				messages.error('The number of days must be greater than the previous reminder.')
			else if ($invoice.reminder_overdue_days_2 > 0 && $invoice.reminder_overdue_days_2 <= days)
				messages.error('The number of days must be less than the next reminder.')
			else setDocument({ reminder_overdue_days_1: days })
		} else messages.error('The number of days must be numeric.')
	}

	const handleInputSecond = (value: string) => {
		let days: number
		if (isNumeric(value)) {
			days = +value
			if (days < 0) messages.error('The number of days must be greater than zero.')
			else if (
				$invoice.reminder_overdue_days >= days ||
				$invoice.reminder_overdue_days_1 >= days ||
				$invoice.reminder_overdue_days >= $invoice.reminder_overdue_days_1
			)
				messages.error('The number of days must be greater than the previous reminder.')
			else setDocument({ reminder_overdue_days_2: days })
		} else messages.error('The number of days must be numeric.')
	}

	let dialogTop = 0
	let dialogRight = 0
	$: {
		//console.log(" Payment-> r:" + $dimensions.divRoot.width + " - i:" + $dimensions.divInvoice.width + " - m:" + $dimensions.divMenu.width)

		// (width div root - width invoicer - width menu) / 2
		if ($dimensions.divRoot.width > 1024)
			dialogRight =
				($dimensions.divRoot.width -
					$dimensions.divInvoice.width -
					$dimensions.divMenu.width +
					36) /
				2
		else if ($dimensions.divRoot.width >= 768)
			dialogRight =
				($dimensions.divRoot.width -
					$dimensions.divInvoice.width -
					$dimensions.divMenu.width +
					36) /
				2
		else if ($dimensions.divRoot.width >= 640)
			dialogRight = ($dimensions.divRoot.width - $dimensions.divInvoice.width + 6) / 2
		else if ($dimensions.divRoot.width >= 480)
			dialogRight = ($dimensions.divRoot.width - $dimensions.divInvoice.width + 12) / 2
		else if ($dimensions.divRoot.width >= 460)
			dialogRight = ($dimensions.divRoot.width - $dimensions.divInvoice.width + 6) / 2
		else dialogRight = 0

		if ($dimensions.divRoot.width >= 480) dialogTop = 90
		else dialogTop = 205

		//console.log("Payment: " + $dimensions.divRoot.width + "px, Right: " + dialogRight + "px")
	}
</script>

<!--svelte:window on:keydown={handleKeydown} /-->

<Dialog on:close bind:posTop={dialogTop} bind:posRight={dialogRight} opacity={0}>
	<!-- "from" fields -->
	<h3 data-test-id="reminder_dialog_title" class="font-bold">Late payment reminders</h3>
	<div class="mt-1 mb-3">
		<div class=" mb-2">Automatically email clients when an invoice is unpaid.</div>
		<div class="flex">
			<input
				data-hj-allow
				type="text"
				class="text-center w-6 border-2 rounded outline-none"
				value={$invoice.reminder_overdue_days}
				on:change={({ currentTarget }) => handleInput(currentTarget.value)}
			/>
			<div class="ml-2">days after the due date.</div>
		</div>
	</div>
	<h3 class="font-bold">Recurring reminders</h3>
	<div class="mt-1 mb-3">
		<div class=" mb-2">Send up to two more reminders after the first one.</div>
		<div class="flex mb-1">
			<input
				type="checkbox"
				class="outline-none"
				disabled={disabledCheckedFirst}
				bind:checked={checkedFirst}
				on:change={({ currentTarget }) => handleCheckFirst(currentTarget.checked)}
			/>

			<!-- send a reminder [x] days after the due date. -->
			<div class="ml-2">Send a reminder</div>
			<input
				data-hj-allow
				type="text"
				class="text-center w-6 ml-2 border-2 rounded outline-none"
				value={$invoice.reminder_overdue_days_1}
				disabled={disabledInputFirst}
				on:change={({ currentTarget }) => handleInputFirst(currentTarget.value)}
			/>
			<div class="ml-2">days after the due date.</div>
		</div>
		<div class="flex mb-1">
			<input
				type="checkbox"
				class="outline-none"
				disabled={disabledCheckedSecond}
				bind:checked={checkedSecond}
				on:change={({ currentTarget }) => handleCheckSecond(currentTarget.checked)}
			/>
			<div class="ml-2">Send a reminder</div>
			<input
				data-hj-allow
				type="text"
				class="text-center w-6 ml-2 border-2 rounded outline-none"
				value={$invoice.reminder_overdue_days_2}
				disabled={disabledInputSecond}
				on:change={({ currentTarget }) => handleInputSecond(currentTarget.value)}
			/>
			<div class="ml-2">days after the due date.</div>
		</div>
	</div>
	<div class="border-b border-gray-300" />
	<div class="mt-3">
		<div class="">
			Reminders are sent at 5am EST. You can set account wide reminders in your settings.
		</div>
	</div>
</Dialog>
